// src/services/abstract/UserService.ts

import type { User, Notification } from "@/types/user/User";

export abstract class UserService {
  abstract getMe(id: string): Promise<User>;
  abstract updateMe(id: string, name?: string, phone?: string, department?: string): Promise<void>;
  abstract getNotifications(): Promise<Notification>;
  abstract getEncapsKey(id: string): Promise<{ encapsKey: string }>;
  abstract getDecapsKey(id: string): Promise<{ decapsKey: string }>;
}
